import * as THREE from 'three';
import { scene } from './scene';
import { rnd } from './util';

export function softDot(){
  const c = document.createElement('canvas'); c.width = c.height = 64; const g = c.getContext('2d');
  const r = g.createRadialGradient(32,32,0,32,32,32); r.addColorStop(0,'rgba(255,255,255,1)'); r.addColorStop(0.35,'rgba(255,255,255,.6)'); r.addColorStop(1,'rgba(255,255,255,0)');
  g.fillStyle = r; g.fillRect(0,0,64,64); return new THREE.CanvasTexture(c);
}
export const dotTex = softDot();
export const clouds = new THREE.Group(); scene.add(clouds);
{ const cm = new THREE.SpriteMaterial({map:dotTex, color:new THREE.Color('#ffe2c8'), transparent:true, opacity:.16, depthWrite:false, fog:true});
  for (let i=0;i<14;i++){ const sp = new THREE.Sprite(cm); const a = Math.random()*Math.PI*2, r = rnd(700, 2200); sp.position.set(Math.cos(a)*r, rnd(380, 700), Math.sin(a)*r); sp.scale.set(rnd(500,1100), rnd(90,200), 1); sp.userData.v = rnd(1.5,4); clouds.add(sp); } }
export class Particles {
  n: number; pos: Float32Array; vel: Float32Array; life: Float32Array; max: Float32Array; head: number;
  geo: THREE.BufferGeometry; mat: THREE.PointsMaterial; pts: THREE.Points; grav: number; drag: number; floor: number;
  constructor(n, o){
    this.n = n; this.pos = new Float32Array(n*3); this.vel = new Float32Array(n*3); this.life = new Float32Array(n); this.max = new Float32Array(n); this.head = 0;
    this.geo = new THREE.BufferGeometry(); this.geo.setAttribute('position', new THREE.BufferAttribute(this.pos,3));
    this.mat = new THREE.PointsMaterial({map:dotTex, size:o.size, transparent:true, opacity:o.opacity, depthWrite:false, blending:o.add?THREE.AdditiveBlending:THREE.NormalBlending, sizeAttenuation:true});
    this.mat.color.setRGB(o.color[0], o.color[1], o.color[2]);
    this.pts = new THREE.Points(this.geo, this.mat); this.pts.frustumCulled = false; scene.add(this.pts);
    this.grav = o.grav; this.drag = o.drag; this.floor = o.floor ?? 0.3;
    for (let i=0;i<n;i++) this.pos[i*3+1] = -1e4;
  }
  emit(p, v, spread, life){
    const i = this.head; this.head = (this.head+1)%this.n;
    this.pos[i*3]=p.x; this.pos[i*3+1]=p.y; this.pos[i*3+2]=p.z;
    this.vel[i*3]=v.x+(Math.random()-.5)*spread; this.vel[i*3+1]=v.y+(Math.random()-.5)*spread; this.vel[i*3+2]=v.z+(Math.random()-.5)*spread;
    this.life[i]=life*(0.6+Math.random()*0.7); this.max[i]=this.life[i];
  }
  update(dt){
    const p=this.pos, v=this.vel;
    for (let i=0;i<this.n;i++){
      if (this.life[i]<=0) continue;
      this.life[i]-=dt; if (this.life[i]<=0){ p[i*3+1]=-1e4; continue; }
      v[i*3+1]+=this.grav*dt; v[i*3]*=this.drag; v[i*3+1]*=this.drag; v[i*3+2]*=this.drag;
      p[i*3]+=v[i*3]*dt; p[i*3+1]+=v[i*3+1]*dt; p[i*3+2]+=v[i*3+2]*dt;
      if (p[i*3+1]<this.floor){ p[i*3+1]=this.floor; v[i*3+1]=0; }
    }
    this.geo.attributes.position.needsUpdate = true;
  }
}
export const dust   = new Particles(3000, {size:9.5, opacity:.42, color:[0.5,0.44,0.38], add:false, grav:-4,  drag:0.985});
export const smoke  = new Particles(1600, {size:26, opacity:.35, color:[0.12,0.1,0.1],  add:false, grav:2.2, drag:0.992, floor:-1});
export const sparks = new Particles(1200, {size:2.4, opacity:.9, color:[3.2,1.2,0.5],   add:true,  grav:-30, drag:0.98});
export const embers = new Particles(600,  {size:4,   opacity:.8, color:[3.0,0.7,0.2],   add:true,  grav:1.5, drag:0.99, floor:-1});

